import { createSelector } from "reselect";
// import { get } from "lodash";
import { State } from "./reducer";
import moment from "moment";
import { get } from "lodash";
export const selectStartDate = (state: any) => {
    const {
        ResourcePlanner_reducer
    }: {
        ResourcePlanner_reducer: State;
    } = state;
    return ResourcePlanner_reducer.startDate;
};

export const selectJobpacks = (state: any) => {
    const {
        ResourcePlanner_reducer
    }: {
        ResourcePlanner_reducer: State;
    } = state;
    return ResourcePlanner_reducer.jobpacks;
};

export const selectWeekCount = (state: any) => {
    const {
        ResourcePlanner_reducer
    }: {
        ResourcePlanner_reducer: State;
    } = state;
    return ResourcePlanner_reducer.weekCount;
};

export const selectTrackOrder = (state: any) => {
    const {
        ResourcePlanner_reducer
    }: {
        ResourcePlanner_reducer: State;
    } = state;
    return ResourcePlanner_reducer.trackOrder;
};

export const selectTrackSubjects = (state: any) => {
    const {
        ResourcePlanner_reducer
    }: {
        ResourcePlanner_reducer: State;
    } = state;
    return ResourcePlanner_reducer.trackSubjects;
};

export const selectStartDateKey = createSelector(
    [selectStartDate],
    startDate => {
        return moment(startDate)
            .format("YYYY-MM-DD")
            .toString();
    }
);

export const selectYearString = createSelector(
    [selectStartDate],
    startDate => {
        return moment(startDate)
            .format("YYYY")
            .toString();
    }
);

export const selectWeekDateStrings = createSelector(
    [selectStartDate, selectWeekCount],
    (startDate, weekCount) => {
        const result = new Array(weekCount * 7).fill(0).map((e, i) => {
            const date = moment(startDate)
                .add(i, "days")
                .format("ddd Do MMM")
                .toString();

            return date;
        });

        return result;
    }
);

export const selectTrackSubjectsForAddMenu = (trackSubjectNames: string[]) =>
    createSelector(
        [selectTrackSubjects, selectTrackOrder],
        (trackSubjects, trackOrder) => {
            const trackSubjectKeys = Object.keys(trackSubjects);
            if (trackSubjectKeys.length === 0) {
                return [];
            }
            for (let i = 0; i < trackOrder.length; ++i) {
                const chosenTrackSubject = trackOrder[i];
                if (trackSubjectKeys.includes(chosenTrackSubject) === true) {
                    const index = trackSubjectKeys.indexOf(chosenTrackSubject);
                    trackSubjectKeys.splice(index, 1);
                }
            }
            const subjectNames = trackSubjectNames.join("");

            const result = trackSubjectKeys.map(key => {
                const subject = trackSubjects[key];
                return {
                    key,
                    name: get(subject, subjectNames)
                };
            });

            return result;
        }
    );

export const selectJobpacksWithVehicles = createSelector(
    [selectJobpacks],
    jobpacks => {
        const result = {} as { [index: string]: any };
        if(jobpacks)Object.keys(jobpacks).map(e => {
            const jobVehicles =
                get(jobpacks[e], "profile.job_vehicles") || null;

            if (jobVehicles !== null) {
                result[e] = jobpacks[e];
            }
            return null;
        });
        return result;
    }
);

export const selectJobpacksForDateRange = createSelector(
    [selectJobpacksWithVehicles, selectWeekCount, selectStartDate],
    (jobpacks, weekCount, startDate) => {
        const days = new Array(weekCount * 7).fill(false);
        const jobpacksForDays = {} as { [index: string]: any };
        Object.entries(jobpacks).map(([key, value]) => {
            const startJobDate = moment(
                get(value, "profile.start_date") || null,
                "DD-MM-YYYY"
            );
            const endJobDate = moment(
                get(value, "profile.end_date", "DD-MM-YYYY") || null,
                "DD-MM-YYYY"
            );

            for (let i = 0; i < weekCount * 7; ++i) {
                const date = moment(startDate).add(i, "days");
                if (date >= startJobDate && date <= endJobDate) {
                    if (days[i] === false) {
                        days[i] = [key];
                    } else {
                        days[i].push(key);
                    }

                    jobpacksForDays[key] = value;
                }
            }

            return null;
        });

        const result = {
            days,
            jobpacks: jobpacksForDays
        };

        return result;
    }
);

const colours = [
    "239, 83, 80",
    "236, 64, 122",
    "171, 70, 187",
    "126, 87, 194",
    "92, 107, 192",
    "66, 165, 245",
    "40, 182, 246",
    "37, 197, 218",
    "38, 166, 154",
    "102, 187, 106",
    "156, 204, 101",
    "212, 225, 87",
    "255, 238, 88",
    "255, 201, 40",
    "255, 167, 37",
    "255, 112, 67"
];
export const selectJobpacksForView = createSelector(
    [selectJobpacksForDateRange, selectWeekCount],
    (jobpacksByDateRange, weekCount) => {
        let vehicles = [] as any[];
        Object.entries(jobpacksByDateRange.jobpacks).map(([key, value]) => {
            vehicles = [...vehicles, ...get(value, "profile.job_vehicles")];
            return null;
        });

        vehicles = vehicles.reduce(
            (acc, curr) => {
                acc[curr.machine_reg] = curr;
                return acc;
            },
            {} as { [index: string]: any }
        );

        const tracks = Object.entries(vehicles).map(([key, value]) => {
            return {
                vehicle: value,
                days: new Array(weekCount * 7).fill(false)
            };
        });

        let colourIndex = 0;

        for (let track = 0; track < tracks.length; ++track) {
            for (let day = 0; day < weekCount * 7; ++day) {
                const jobpackKeys = jobpacksByDateRange.days[day];

                if (Array.isArray(jobpackKeys)) {
                    for (
                        let jobpackID = 0;
                        jobpackID < jobpackKeys.length;
                        ++jobpackID
                    ) {
                        const jobpack =
                            jobpacksByDateRange.jobpacks[
                                jobpackKeys[jobpackID]
                            ];

                        for (
                            let v = 0;
                            v < jobpack.profile.job_vehicles.length;
                            v++
                        ) {
                            const vehicle = jobpack.profile.job_vehicles[v];
                            if (
                                vehicle.machine_reg ===
                                tracks[track].vehicle.machine_reg
                            ) {
                                if (tracks[track].days[day] === false) {
                                    tracks[track].days[day] = [
                                        {
                                            ...jobpack,
                                            colour: colours[colourIndex]
                                        }
                                    ];
                                } else {
                                    tracks[track].days[day].push({
                                        ...jobpack,
                                        colour: colours[colourIndex]
                                    });
                                }

                                colourIndex++;
                                colourIndex %= colours.length;
                            }
                        }
                    }
                }
            }
        }

        return tracks;
    }
);

export const selectTracksForView = createSelector(
    [
        selectJobpacksForView,
        selectWeekCount,
        selectTrackSubjects,
        selectTrackOrder
    ],
    (jobpacksForView, weekCount, trackSubjects, trackOrder) => {
        if (
            !Array.isArray(trackOrder) ||
            trackOrder.length === 0 ||
            Object.keys(trackSubjects).length === 0
        ) {
            return [];
        }
        const emptyDays = new Array(7 * weekCount).fill(false);

        const result = trackOrder.map((e, i) => {
            let vehicle = get(trackSubjects, `${e}.profile`) || {
                machine_reg: `Undefined ${i}`,
                machine_desc: `Undefined ${i}`
            };

            let days = emptyDays;
            for (let i = 0; i < jobpacksForView.length; ++i) {
                if (
                    jobpacksForView[i].vehicle.machine_reg ===
                    vehicle.machine_reg
                ) {
                    days = jobpacksForView[i].days;
                }
            }
            return {
                vehicle,
                days
            };
        });

        return result;
    }
);
